// src/modules/app-views/ticket-events/pages/Init/components/tableColumns/ticketsColumn.js
import translateX from 'utils/translateX';
import { Progress } from 'antd';

function ticketsColumn(buildColumnProps) {
  return {
    key: 'soldTickets',
    title: translateX('tickets'),
    dataIndex: 'soldTickets',
    width: 150,
    ...buildColumnProps('soldTickets', { sort: true }),
    render: (_, r) => {
      const sold = r?.soldTickets || 0;
      const total = r?.totalTickets || 0;
      const pct = total > 0 ? Math.round((sold / total) * 100) : 0;
      return (
        <div>
          <span style={{ fontSize: 12 }}>{sold} / {total}</span>
          <Progress percent={pct} size="small" showInfo={false} />
        </div>
      );
    },
  };
}

export default ticketsColumn;
